export default __webpack_public_path__ + "12fb0c184deba19986e99b70ea7d047c.svg";